import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Cart from '../components/Cart';
import WhatsAppWidget from '../components/WhatsAppWidget';
import ContactSection from '../components/ContactSection';
import LuminexHero from '../components/homev2/LuminexHero';
import MappingVisual from '../components/homev2/MappingVisual';
import { PowerSection, IntelligenceSection, VacuumMopSection, SelfEmptySection, CoverageHepaSection } from '../components/homev2/StorySections';
import { BeautyShot, VideoMoment } from '../components/homev2/BeautyShot';
import { Ecosystem, Commercial } from '../components/homev2/Ecosystem';
import { WhyEditorial, GuidesEditorial, LuminexFaq, StickyBuyBar } from '../components/homev2/HomeTail';
import { BrandHero, FamilyCards, Innovation, HarpalykCare } from '../components/homev2/BrandSections';
import { useCart } from '../context/CartContext';
import { trackEvent } from '../lib/analytics';

const API = process.env.REACT_APP_BACKEND_URL;

export default function HomeV2() {
  const [scrolled, setScrolled] = useState(false);
  const [luminex, setLuminex] = useState(null);
  const { addToCart, setIsCartOpen } = useCart();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    axios.get(`${API}/api/products/luminex-300`).then(({ data }) => setLuminex(data)).catch(() => {});
  }, []);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash && !hash.includes('session_id')) {
      const id = hash.slice(1);
      let tries = 0;
      const timer = setInterval(() => {
        const el = document.getElementById(id);
        tries += 1;
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
          clearInterval(timer);
        } else if (tries > 20) {
          clearInterval(timer);
        }
      }, 250);
      return () => clearInterval(timer);
    }
  }, []);

  const buyLuminex = () => {
    trackEvent('homepage_luminex_buy');
    if (luminex) {
      addToCart(luminex);
      setIsCartOpen(true);
    } else {
      window.location.href = '/products/luminex-300';
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] relative">
      <Helmet>
        <title>Harpalyk Robotics — Intelligent Cleaning Robots for India | SMARTBOT, SHINEBOT, POOLBOT & LAWNBOT</title>
        <meta name="description" content="Harpalyk Robotics builds intelligent robots for Indian homes and businesses — SMARTBOT floor cleaning robots, SHINEBOT window robots, POOLBOT pool cleaners and LAWNBOT robotic lawn mowers. Book a free demo." />
        <link rel="canonical" href="https://harpalyk.com/" />
      </Helmet>
      <Header scrolled={scrolled} />
      <main>
        <BrandHero />
        <FamilyCards />
        <LuminexHero onBuy={buyLuminex} />
        <PowerSection />
        <IntelligenceSection />
        <MappingVisual />
        <VacuumMopSection />
        <SelfEmptySection />
        <CoverageHepaSection />
        <BeautyShot onBuy={buyLuminex} />
        <VideoMoment />
        <Ecosystem />
        <Commercial />
        <Innovation />
        <GuidesEditorial />
        <WhyEditorial />
        <HarpalykCare />
        <LuminexFaq />
        <ContactSection />
      </main>
      <StickyBuyBar onBuy={buyLuminex} />
      <Footer />
      <Cart />
      <WhatsAppWidget />
    </div>
  );
}
